import { error, message } from "laravel-mix/src/Log";

export default class ErrorService {
    constructor() {
        this.initHandler();
    }

    static onError(error) {

    }

    static initHandler(){
        const scope = this;
        window.onerror = (message, url, lineNo, columnNo, error) => {
            console.log(error, "test errror");
        }
        if(error){
            scope.onError(error);
            console.group("Error Handler")
            console.log(message, url, lineNo, columnNo, error);
            console.groupEnd();
        }
    }
}
